'use strict';

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Button = _ref.Button;

  var FullscreenCtaButton = function (_React$Component) {
    _inherits(FullscreenCtaButton, _React$Component);

    function FullscreenCtaButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, FullscreenCtaButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = FullscreenCtaButton.__proto__ || Object.getPrototypeOf(FullscreenCtaButton)).call.apply(_ref2, [this].concat(args))), _this), _this.renderButton = function () {
        var _this$props = _this.props,
            buttonProps = _this$props.buttonProps,
            onCtaClick = _this$props.onCtaClick;
        return _react2['default'].createElement(Button, {
          text: buttonProps.text,
          clickHandler: onCtaClick,
          bgColor: buttonProps.bgColor,
          color: buttonProps.textColor,
          link: buttonProps.link,
          size: 'small',
          noWrap: true
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FullscreenCtaButton, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            isDesktop = _props.isDesktop;
        return _react2['default'].createElement('div', {
          className: this.fullscreenCtaClass
        }, isDesktop && _react2['default'].createElement('div', {
          className: theme.buttonContainer
        }, this.renderButton()), !isDesktop && this.renderButton());
      }
    }, {
      key: 'fullscreenCtaClass',
      get: function get() {
        var _cn;

        var _props2 = this.props,
            theme = _props2.theme,
            ctaVisible = _props2.ctaVisible;
        return (0, _classnames2['default'])(theme.fullscreenCta, (_cn = {}, _defineProperty(_cn, theme.active, ctaVisible), _defineProperty(_cn, theme.inactive, !ctaVisible), _cn));
      }
    }]);

    return FullscreenCtaButton;
  }(_react2['default'].Component);

  FullscreenCtaButton.displayName = identifier;
  FullscreenCtaButton.propTypes = {
    theme: _propTypes2['default'].object.isRequired,
    onCtaClick: _propTypes2['default'].func.isRequired,
    buttonProps: _propTypes2['default'].object.isRequired,
    ctaVisible: _propTypes2['default'].bool.isRequired,
    isDesktop: _propTypes2['default'].bool
  };
  return FullscreenCtaButton;
};

exports['default'] = factory;